import { useState } from 'react'
import {
  DateRangeSelection,
  getRelativeRange
} from '@contrast-security-inc/design-system-inputs'

export const defaultDateRange: DateRangeSelection = getRelativeRange({
  count: 30,
  unit: 'DAYS',
  type: 'RELATIVE_TO_NOW'
})

export interface UseVrDateFilterManagerChildResponse {
  selectedDateRange?: DateRangeSelection
  onDateRangeOptionSelect: (selectedRange: DateRangeSelection) => void
}
export const useVrDateFilterManager: () => UseVrDateFilterManagerChildResponse =
  () => {
    const [selectedDateRange, setSelectedDateRange] =
      useState<DateRangeSelection>(defaultDateRange)

    const onDateRangeOptionSelect = (dateRangeOption: DateRangeSelection) => {
      setSelectedDateRange(dateRangeOption)
    }

    return {
      selectedDateRange,
      onDateRangeOptionSelect
    }
  }
